/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddWordDto } from '../../models/add-word-dto';

export interface LpInspectionControllerAddWord$Params {
  id: string;
      body: AddWordDto
}

export function lpInspectionControllerAddWord(http: HttpClient, rootUrl: string, params: LpInspectionControllerAddWord$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'valid': boolean;
'pass': boolean;
}>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionControllerAddWord.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'valid': boolean;
      'pass': boolean;
      }>;
    })
  );
}

lpInspectionControllerAddWord.PATH = '/api/lp-inspection/{id}/word';
